import { getTestIds } from 'seagull/utils/TestIds';
export const getServicePriceEditorV2TID = () => getTestIds({
  deprecatedTestIds: {
    ServicePriceEditorV2TID: {
      CloseButton: 'price-editor-popover-close',
      SaveButton: 'price-editor-save',
      CancelButton: 'price-editor-cancel',
      UnitNameTextField: 'sb-unit-name',
      MinPriceTextField: 'sb-min-price',
      PriceTextField: 'sb-price',
      DiscountInput: 'sb-discount',
      PriceAfterDiscount: 'price-editor-final-price'
    }
  }
});